import React from 'react'
import LoadingComponent from '../../components/loading'

function Loading() {
  return <LoadingComponent fixed />
}

export default Loading
